{
  "form": {
    "input_placeholder": "افزودن وظیفه…",
    "parseWithAi_aria": "تجزیه وظیفه با هوش مصنوعی",
    "parseWithAi_title": "پاک‌سازی و تعیین اولویت با هوش مصنوعی",
    "priorityLabel_aria": "اولویت وظیفه",
    "add": "افزودن",
    "signInForAi": "برای استفاده از ویژگی‌های هوش مصنوعی وارد شوید.",
    "aiUnavailable": "هوش مصنوعی در دسترس نیست. دوباره تلاش کنید.",
    "saveTo": "ذخیره در",
    "saveTo_aria": "ذخیره در {{list}}",
    "saveToSynced_aria": "ذخیره در {{list}}، {{provider}}",
    "addedTo": "به {{list}} اضافه شد",
    "addedToSynced": "به {{list}} اضافه شد · {{provider}}",
    "show": "نمایش"
  },
  "priority": {
    "Critical": "بحرانی",
    "High": "بالا",
    "Medium": "متوسط",
    "Low": "پایین"
  },
  "item": {
    "edit_aria": "ویرایش وظیفه",
    "delete_aria": "حذف وظیفه",
    "addStep": "افزودن یک گام",
    "addStep_placeholder": "افزودن یک گام…",
    "addStep_aria": "افزودن گامی به {{task}}",
    "steps_group_aria": "گام‌های {{task}}",
    "steps_progress_aria": "{{done}} از {{count}} گام انجام شده",
    "completeSteps_aria": "{{task}}. {{count}} گام باز نیز کامل می‌شود"
  },
  "list": {
    "title": "وظایف",
    "newListFallback": "فهرست جدید",
    "completedMeta": "{{completed}} از {{total}} انجام‌شده",
    "deleteConfirm": "«{{name}}» حذف شود؟",
    "rename_title": "تغییر نام",
    "deleteList_title": "حذف فهرست",
    "newListName_placeholder": "نام فهرست…",
    "newList": "فهرست جدید",
    "done": "انجام‌شده",
    "emptyTitle": "هنوز وظیفه‌ای نیست",
    "emptySubtitle": "برای شروع یکی را در پایین اضافه کنید.",
    "noFilterMatch": "وظیفه‌ای با این فیلتر مطابقت ندارد.",
    "createIn": "ایجاد در",
    "inDestination": "در {{destination}}",
    "createIn_aria": "ایجاد در {{destination}}",
    "createInAccount_aria": "ایجاد در {{destination}}، {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "در حال ایجاد در {{destination}}…",
    "createFailed": "ایجاد «{{name}}» در {{destination}} ممکن نشد.",
    "createLimit": "{{destination}} به سقف فهرست‌ها رسیده است.",
    "keepInRhemn": "در Rhemn بماند"
  },
  "filter": {
    "label": "فیلتر",
    "all": "همه"
  },
  "voice": {
    "mic_aria": "افزودن کار با صدا",
    "mic_title": "کارهایت را بگو — بر اساس اولویت و زمان مرتب می‌شوند",
    "stop_aria": "توقف و مرتب‌سازی کارها",
    "recording": "در حال ضبط",
    "sorting": "در حال مرتب‌سازی کارها…",
    "stripTitle": "کارهای شنیده‌شده",
    "stripCount": "{{checked}} از {{total}}",
    "discard": "رد کردن",
    "addN": "افزودن {{count}}",
    "addZero": "افزودن",
    "adding": "در حال افزودن…",
    "parseFallback": "مرتب‌سازی نشد — حرف‌هایت در کادر است.",
    "nothingHeard": "چیزی شنیده نشد — دوباره تلاش کن.",
    "micDenied": "میکروفون مسدود است — در تنظیمات اجازه بده.",
    "gateBody": "کارهایت را بگو — بر اساس اولویت و وقت نماز مرتب می‌شوند. همراه Pro.",
    "listen_aria": "در حال شنیدن — کارهایت را بگو"
  }
}
